export const FULL_SCORE_AVERAGE_STARS = 4.8;
export const ZERO_SCORE_AVERAGE_STARS = 4.0;
export const STARS_DECIMALS = 1;
